import React, { Component } from 'react';
import { withFormik, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Accordion } from 'react-bootstrap';
import { connect } from 'react-redux';
import { sendAlert } from '../../actions/utils';
import { daysOfWeek } from './FormOptions';
import './style.scss';
import GeneralData from './Accordion/GeneralData';
import ToleranceTab from './Accordion/Tolerance';
import Colation from './Accordion/Colation';
import Flexibility from './Accordion/Flexibility';
import Assignment from './Accordion/Assignment';
import WeekDistribution from './Accordion/WeekDistribution';

const TAB_KEYS = {
  general: '0',
  tolerance: '1',
  colation: '2',
  flexibility: '3',
  distribution: '4',
  assignment: '5'
};

const KEY_TO_TAB = {
  '0': 'general',
  '1': 'tolerance',
  '2': 'colation',
  '3': 'flexibility',
  '4': 'distribution',
  '5': 'assignment'
};

class ShiftForm extends Component {
  state = {
    accordion: 'general',
    activeKey: '0'
  };

  constructor(props) {
    super(props);
    this.timeout = null;
  }

  handleChangeTab = tab => {
    this.setState({
      accordion: tab,
      activeKey: TAB_KEYS[tab] || '0'
    });
  };

  handleAccordionSelect = key => {
    this.setState({
      activeKey: key || null,
      accordion: KEY_TO_TAB[key] || ''
    });
  };

  dayCheckBoxValue = (day, index, element) => {
    const { setFieldValue, values } = this.props;
    const currentSend = Boolean(values?.shift?.shiftDaysAttributes?.[index]?.send);
    const newSend = !currentSend;
    if (element?._dispatchListeners?.[0] === undefined && values?.shift?.shiftDaysAttributes?.[index]) {
      values.shift.shiftDaysAttributes[index].send = newSend;
    }
    setFieldValue(`shift[shiftDaysAttributes][${index}][send]`, newSend);
    setFieldValue(`shift[shiftDaysAttributes][${index}][weekDay]`, day);
  };

  getErrorForTab = (tab, shiftErrors) => {
    switch (tab) {
      case 'general': {
        const fields = [
          'name',
          'acronym',
          'description',
          'workdayNumber',
          'beginExceptionalWorkday',
          'expirationExceptionalWorkday',
          'exceptionalShiftCycle'
        ];
        const errorField = fields.find(f => shiftErrors[f]);
        if (errorField) {
          return { tab: 'general', message: shiftErrors[errorField] };
        }
        return null;
      }
      case 'colation': {
        if (shiftErrors.collationTime || shiftErrors.agreedSchedule) {
          return {
            tab: 'colation',
            message: 'Debes seleccionar una de las opciones de marcado en Colación (Horario pactado o Tiempo pactado)'
          };
        }
        if (shiftErrors.lunchTime) {
          return {
            tab: 'colation',
            message: 'Debes ingresar los minutos de colación en la sección Colación'
          };
        }
        if (shiftErrors.imputableColation) {
          return { tab: 'colation', message: 'Error en Colación Imputable Jornada' };
        }
        return null;
      }
      case 'tolerance': {
        const fields = ['tolerance', 'exitTolerance', 'arrivalBreakTolerance', 'departureBreakTolerance'];
        const errorField = fields.find(f => shiftErrors[f]);
        if (errorField) {
          return { tab: 'tolerance', message: shiftErrors[errorField] };
        }
        return null;
      }
      case 'flexibility': {
        const fields = ['initialTime', 'maximumStartTime', 'workHours'];
        const errorField = fields.find(f => shiftErrors[f]);
        if (errorField) {
          return { tab: 'flexibility', message: shiftErrors[errorField] };
        }
        return null;
      }
      case 'distribution': {
        if (shiftErrors.shiftDaysAttributes) {
          if (typeof shiftErrors.shiftDaysAttributes === 'string') {
            return { tab: 'distribution', message: shiftErrors.shiftDaysAttributes };
          }
          if (Array.isArray(shiftErrors.shiftDaysAttributes)) {
            const firstDayError = shiftErrors.shiftDaysAttributes.find(item => item && typeof item === 'object');
            if (firstDayError) {
              const firstMsg = Object.values(firstDayError)[0];
              return {
                tab: 'distribution',
                message: `Distribución: ${firstMsg}`
              };
            }
          }
          return {
            tab: 'distribution',
            message: 'Debes verificar los horarios en Distribución Semanal'
          };
        }
        return null;
      }
      case 'assignment': {
        if (shiftErrors.contractIds) {
          return { tab: 'assignment', message: shiftErrors.contractIds };
        }
        return null;
      }
      default:
        return null;
    }
  };

  getErrorTabAndMessage = (shiftErrors, currentTab) => {
    if (!shiftErrors) {
      return { tab: null, message: null };
    }

    const currentTabError = this.getErrorForTab(currentTab, shiftErrors);
    if (currentTabError) {
      return currentTabError;
    }

    const tabOrder = ['general', 'flexibility', 'tolerance', 'colation', 'distribution', 'assignment'];
    for (let i = 0; i < tabOrder.length; i += 1) {
      const tabError = this.getErrorForTab(tabOrder[i], shiftErrors);
      if (tabError) {
        return tabError;
      }
    }

    const firstKey = Object.keys(shiftErrors)[0];
    const fallbackMsg =
      typeof shiftErrors[firstKey] === 'string'
        ? shiftErrors[firstKey]
        : 'Por favor revisa los campos requeridos del formulario';

    return {
      tab: 'general',
      message: fallbackMsg
    };
  };

  handleSaveClick = async e => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const { onHide, validateForm, setTouched, sendAlert: triggerAlert, submitForm } = this.props;
    const { accordion } = this.state;

    const errors = await validateForm();
    if (errors && errors.shift && Object.keys(errors.shift).length > 0) {
      const shiftErrors = errors.shift;
      const touchedShift = {};
      Object.keys(shiftErrors).forEach(key => {
        if (key === 'shiftDaysAttributes' && Array.isArray(shiftErrors.shiftDaysAttributes)) {
          touchedShift.shiftDaysAttributes = shiftErrors.shiftDaysAttributes.map(item => {
            if (!item) return {};
            const itemTouched = {};
            Object.keys(item).forEach(k => {
              itemTouched[k] = true;
            });
            return itemTouched;
          });
        } else {
          touchedShift[key] = true;
        }
      });
      setTouched({ shift: touchedShift });

      const { tab, message } = this.getErrorTabAndMessage(shiftErrors, accordion);
      if (tab) {
        this.handleChangeTab(tab);
      }
      if (triggerAlert && message) {
        triggerAlert({ kind: 'error', message });
      }
      return;
    }

    if (onHide) {
      onHide();
    }
    submitForm();
  };

  render() {
    const { accordion, activeKey } = this.state;
    const { values, errors, touched, setFieldValue, shift, disabled, rrhh = true } = this.props;
    const { exceptionalWorkday, flexibleShift, shiftType } = values.shift;

    return (
      <Form onSubmit={this.handleSaveClick}>
        <Accordion activeKey={activeKey} onSelect={this.handleAccordionSelect}>
          <GeneralData
            currentTab={accordion}
            disabled={disabled}
            errors={errors}
            exceptionalWorkday={exceptionalWorkday}
            extensionDefaultValue="weekly_extension"
            onChangeTab={this.handleChangeTab}
            setFieldValue={setFieldValue}
            shiftType={shiftType}
            touched={touched}
          />
          <Flexibility
            currentTab={accordion}
            disabled={disabled}
            errors={errors}
            getIn={getIn}
            onChangeTab={this.handleChangeTab}
            setFieldValue={setFieldValue}
            touched={touched}
            values={values}
          />
          <ToleranceTab
            currentTab={accordion}
            disabled={disabled}
            errors={errors}
            flexibleShift={flexibleShift}
            onChangeTab={this.handleChangeTab}
            setFieldValue={setFieldValue}
            touched={touched}
            values={values}
          />
          <Colation
            currentTab={accordion}
            disabled={disabled}
            errors={errors}
            onChangeTab={this.handleChangeTab}
            setFieldValue={setFieldValue}
            touched={touched}
            values={values}
          />
          <WeekDistribution
            currentTab={accordion}
            dayCheckBoxValue={this.dayCheckBoxValue}
            disabled={disabled}
            errors={errors}
            getIn={getIn}
            onChangeTab={this.handleChangeTab}
            setFieldValue={setFieldValue}
            touched={touched}
            values={values}
          />
          {rrhh && (
            <Assignment
              currentTab={accordion}
              disabled={disabled}
              errors={errors}
              getIn={getIn}
              onChangeTab={this.handleChangeTab}
              setFieldValue={setFieldValue}
              shift={shift}
              touched={touched}
            />
          )}
        </Accordion>
        {!disabled && (
          <Row className="d-flex justify-content-end my-3">
            <Col md={3}>
              <Button type="button" variant="primary" block onClick={this.handleSaveClick}>
                Guardar
              </Button>
            </Col>
          </Row>
        )}
      </Form>
    );
  }
}

const setInitialValues = props => {
  const { action } = props;
  const { shiftDaysAttributes } = props.shift || {};
  let shiftDays = daysOfWeek;
  if (shiftDaysAttributes && shiftDaysAttributes.length) {
    shiftDays = daysOfWeek.map(day => {
      const shiftDay = shiftDaysAttributes.filter(item => item && item.weekDay === day.value);
      if (shiftDay.length) {
        const isSend =
          shiftDay[0].send !== undefined ? Boolean(shiftDay[0].send === true || shiftDay[0].send === 'true') : true;
        return {
          ...shiftDay[0],
          send: isSend,
          telecommuting: Boolean(shiftDay[0].telecommuting)
        };
      }
      return { ...day, send: false, telecommuting: false };
    });
  }
  const hasSelectedDays = shiftDays.some(item => item && item.send);
  const shiftEmpty = shiftDays.map(day => ({
    ...day,
    send: false,
    telecommuting: false
  }));

  return {
    shift: {
      ...props.shift,
      shiftDaysAttributes: action === 'new' && !hasSelectedDays ? shiftEmpty : shiftDays,
      shiftType: 'weekly'
    }
  };
};

const validationSchema = Yup.object().shape({
  shift: Yup.object().shape(
    {
      workHolidays: Yup.boolean(),
      imputableColation: Yup.boolean(),
      tolerance: Yup.number().when('flexibleShift', {
        is: val => val !== 'true',
        then: Yup.number()
          .required('Debes ingresar una tolerancia')
          .min(0, 'Debe ser mayor o igual a 0')
      }),
      exitTolerance: Yup.number().when('flexibleShift', {
        is: val => val !== 'true',
        then: Yup.number()
          .required('Debes ingresar una tolerancia')
          .min(0, 'Debe ser mayor o igual a 0')
      }),
      arrivalBreakTolerance: Yup.number().when('flexibleShift', {
        is: val => val !== 'true',
        then: Yup.number().min(0, 'Debe ser mayor o igual a 0')
      }),
      departureBreakTolerance: Yup.number().when('flexibleShift', {
        is: val => val !== 'true',
        then: Yup.number().min(0, 'Debe ser mayor o igual a 0')
      }),
      lunchCheck: Yup.bool(),
      collationTime: Yup.bool().when('agreedSchedule', {
        is: aSchedule => aSchedule === false,
        then: Yup.bool().oneOf([true], 'Debes seleccionar una opción')
      }),
      agreedSchedule: Yup.bool().when('collationTime', {
        is: colTime => colTime === false,
        then: Yup.bool().oneOf([true], 'Debes seleccionar una opción')
      }),
      lunchTime: Yup.number()
        .typeError('Debes ingresar un número')
        .when('collationTime', {
          is: val => val,
          then: Yup.number()
            .typeError('Debes ingresar un número')
            .required('Debes ingresar un número')
            .min(0, 'Debe ser mayor o igual a 0 '),
          otherwise: Yup.number().nullable()
        }),
      initialTime: Yup.string().when('flexibleShift', {
        is: val => val,
        then: Yup.string().required('Debes ingresar un horario'),
        otherwise: Yup.string().nullable()
      }),
      maximumStartTime: Yup.string().when('flexibleShift', {
        is: val => val,
        then: Yup.string().required('Debes ingresar tiempo máximo de inicio')
      }),
      workHours: Yup.string().when('flexibleShift', {
        is: val => val,
        then: Yup.string().required('Debes ingresar cantidad de horas a trabajar')
      }),
      name: Yup.string()
        .required('Debes ingresar un nombre')
        .max(80, 'Máximo 80 caracteres'),
      acronym: Yup.string()
        .required('Debes ingresar las siglas del turno')
        .max(5, 'Máximo 5 caracteres'),
      description: Yup.string()
        .required('Debes ingresar la descripción del turno')
        .max(100, 'Máximo 100 caracteres'),
      workdayNumber: Yup.string().when('exceptionalWorkday', {
        is: val => val === true,
        then: Yup.string()
          .required('Debes ingresar el número de jornada')
          .max(15, 'Máximo 15 caracteres')
      }),
      beginExceptionalWorkday: Yup.string().when('exceptionalWorkday', {
        is: val => val === true,
        then: Yup.string().required('Debes ingresar la fecha de inicio')
      }),
      expirationExceptionalWorkday: Yup.string().when('exceptionalWorkday', {
        is: val => val === true,
        then: Yup.string().required('Debes ingresar la fecha de vencimiento')
      }),
      exceptionalShiftCycle: Yup.string().when('exceptionalWorkday', {
        is: val => val === true,
        then: Yup.string()
          .required('Debes ingresar la descripción del ciclo')
          .min(5, 'Mínimo 5 caracteres')
          .max(100, 'Máximo 120 caracteres')
      }),
      shiftDaysAttributes: Yup.array()
        .when('agreedSchedule', {
          is: val => val,
          then: Yup.array().of(
            Yup.object({
              endLunch: Yup.string().when('send', {
                is: val => val,
                then: Yup.string()
                  .required('Debes ingresar hora de término')
                  .test(
                    'is-greater',
                    'La hora de término debe ser mayor o igual que la hora de inicio',
                    function isGreaterTest(value) {
                      const { startLunch } = this.parent;
                      return startLunch && value >= startLunch;
                    }
                  ),
                otherwise: Yup.string().nullable()
              }),
              startLunch: Yup.string().when('send', {
                is: val => val,
                then: Yup.string().required('Debes ingresar hora de inicio'),
                otherwise: Yup.string().nullable()
              })
            })
          )
        })
        .of(
          Yup.object().shape({
            endTime: Yup.string().when('send', {
              is: val => val,
              then: Yup.string()
                .required('Debes ingresar hora de término')
                .notOneOf([Yup.ref('startTime'), null], 'Las horas de inicio y termino no pueden ser iguales'),
              otherwise: Yup.string().nullable()
            }),
            startTime: Yup.string().when('send', {
              is: val => val,
              then: Yup.string().required('Debes ingresar hora de inicio'),
              otherwise: Yup.string().nullable()
            }),
            send: Yup.boolean()
          })
        )
    },
    [['agreedSchedule', 'collationTime']]
  )
});

const handleSubmit = (values, { props }) => {
  const { formRequest } = props;
  formRequest(values);
};

export default connect(null, { sendAlert })(
  withFormik({
    mapPropsToValues: props => setInitialValues(props),
    validationSchema,
    handleSubmit,
    validateOnMount: props => props.action !== 'new'
  })(ShiftForm)
);
